import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatError, MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { Router } from '@angular/router';

@Component({
  selector: 'app-link-expirado',
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    CommonModule,
    MatButtonModule,
  ],
  templateUrl: './link-expirado.html',
  styleUrl: './link-expirado.scss',
})
export class LinkExpirado {
  form = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
  });

  constructor(private router: Router) {}

  ngOnInit() {
    const savedEmail = localStorage.getItem('recovery_email');
    if (savedEmail) {
      this.form.get('email')?.setValue(savedEmail);
    }
  }

  solicitarNovoLink() {
    const email = this.form.get('email')?.value;
    // Aqui você pode reenviar o código via API se quiser
    this.router.navigate(['/auth/recuperar-senha'], {
      queryParams: { email },
    });
  }

  voltarParaLogin() {
    this.router.navigate(['/auth/login']);
  }
}
